import React from 'react';
import {ReactComponent as LogoIcon} from '../../../../assets/header/logo.svg';
import {ReactComponent as OfflineIcon} from '../../../../assets/i/offline.svg';

export const OfflineContainer = () => {
    return (
        <div className='offline-container'>
            <div className='offline-left'>
                <div className='offline-left-svg'>
                    <OfflineIcon/>
                </div>
            </div>
            <div className='offline-right'>
                <div className='offline-right-box'>
                    <div className="offline-right-logo-box">
                        <LogoIcon/>
                    </div>
                    <div className="offline-right-text-box">
                        <span>Не удается загрузить страницу, так как Вы сейчас находитесь не онлайн.</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

